import React from "react";
import "../styles/WhatWeDeliver.css";

const services = [
  {
    id: "01",
    title: "SEO & Organic Growth",
    description:
      "Technical SEO, content strategy, and link building that compounds over time. We build organic visibility that generates traffic and leads without paying for every click.",
  },
  {
    id: "02",
    title: "PPC & Paid Advertising",
    description:
      "Surgical paid campaigns across Google, Meta, and LinkedIn. Every dollar tracked, optimized, and tied to a business outcome — not vanity metrics.",
  },
  {
    id: "03",
    title: "Social Media Marketing",
    description:
      "Strategic social presence that builds brand equity and drives engagement. Content calendars, community management, and paid amplification working as one system.",
  },
  {
    id: "04",
    title: "Email Marketing & Automation",
    description:
      "Nurture sequences, drip campaigns, and lifecycle marketing that convert subscribers into customers and customers into advocates.",
  },
  {
    id: "05",
    title: "Content Marketing",
    description:
      "Blog posts, thought leadership, video content, and content ecosystems designed to educate, engage, and convert your ideal audience.",
  },
  {
    id: "06",
    title: "Analytics & Reporting",
    description:
      "Real-time dashboards, attribution modeling, and performance analysis that give you clarity on what's working and where to invest next.",
  },
];

const WhatWeDeliver = () => {
  return (
    <section className="deliver-section">
      <div className="deliver-container">

        <div className="deliver-header">
          <h2>What We Deliver</h2>

          <p>
            Full-spectrum digital marketing services designed to generate
            awareness, drive consideration, and accelerate pipeline.
          </p>
        </div>

        <div className="deliver-grid">
          {services.map((item) => (
            <div className="deliver-card" key={item.id}>
              <span className="service-number">{item.id}</span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhatWeDeliver;